export default __webpack_public_path__ + "static/testimonial-client-f1e5e06a501153cf0b7c524d0169c520.png";